<template>
  <transition name="fade" appear>
    <div class="app" v-if="!isLoading">
      <div class="app__header">
        <VBlock max-width="378px">
          <img src="@/assets/app-logo.png" />
        </VBlock>
      </div>

      <div class="app__content">
        <transition name="fade" mode="out-in" appear>
          <router-view :key="$route.fullPath" v-if="!isLoading" />
        </transition>
      </div>

      <div class="app__footer">
        <VBlock max-width="100%">
          <img src="@/assets/app-footer.png" />
        </VBlock>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { RESET_LOADING, BEGIN_LOADING, END_LOADING } from '@/store';
import config from '@/config';

export default {
  name: 'App',

  created() {
    const { languageCode } = config;

    this.$store.commit(RESET_LOADING);

    this.loadDictionary(languageCode);
  },

  computed: {
    ...mapGetters([
      'isLoading',
    ]),
  },

  methods: {
    async loadDictionary(languageCode) {
      const FAKE_DELAY = 500;

      this.$store.commit(BEGIN_LOADING);

      this.$i18n.setLocaleMessage(
        languageCode,
        (await this.$bricodes.getDictionary(languageCode)).data,
      );

      this.$i18n.locale = languageCode;

      setTimeout(() => {
        this.$store.commit(END_LOADING);
      }, FAKE_DELAY);
    },
  },
};
</script>

<style lang="scss">
@import 'reset-css';
@import '~vue2-animate/dist/vue2-animate.min.css';
@import '~animate.css/animate.min.css';

@font-face {
  font-family: 'Comedy Sans Condensed';
  src: url('~@/assets/ComedySansCondensed-Bold.woff2') format('woff2'),
    url('~@/assets/ComedySansCondensed-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Comedy Sans Condensed';
  src: url('~@/assets/ComedySansCondensed-Black.woff2') format('woff2'),
    url('~@/assets/ComedySansCondensed-Black.woff') format('woff');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}



*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  background-image: url('~@/assets/body-background-cover.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center center;
}

.app {
  overflow: hidden;

  display: flex;
  flex-direction: column;

  min-height: 100%;
  max-width: $appWidth;
  margin: 0 auto;

  font-family: Arial, Helvetica, sans-serif;
  font-size: font(18px, 40px);

  background-color: #ffffff;
  background-image: url('~@/assets/app-background.png');
  background-repeat: repeat-y;
  background-size: 100% auto;
  background-position: top center;

  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);

  &__header {
    padding: 40px 0;
    background-image: url('~@/assets/app-header.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  &__content {
    flex: 1 1 auto;
  }
}

hr {
  display: block;
  width: 100%;
  max-width: 520px;
  height: 8px;

  margin: 16px auto;
  background-color: #000000;

  border: 0;
}
</style>
